<template>
    <div 
        class="iat-category-header d-flex px-4 py-3"
        :class="positioning"
    >
        <div
            v-if="showLeft"
            class="iat-category-header__control-description text-center"
        >
            <div class="iat-category-header__control-description--small iat-category-header__control-description--mobile">
                {{ $t(`${TEXT_TYPES.INTERACTION_BASE}_IAT_PRESS_LEFT_MOBILE`) }}
            </div>
            <div class="iat-category-header__control-description--small iat-category-header__control-description--desktop">
                {{ $t(`${TEXT_TYPES.INTERACTION_BASE}_IAT_PRESS_LEFT`) }}
            </div>
            <div v-if="categories.topLeft && !categories.topLeft.isHidden" class="iat-category-header__control-description--large iat-category-header__target">
                {{ categories.topLeft && categories.topLeft.title }}
            </div>
            <div v-if="categories.bottomLeft && !categories.bottomLeft.isHidden && categories.topLeft && !categories.topLeft.isHidden" class="iat-category-header__control-description--small">
                {{ $t(`${TEXT_TYPES.INTERACTION_BASE}_IAT_PRESS_OR`) }}
            </div>
            <div v-if="categories.bottomLeft && !categories.bottomLeft.isHidden"  class="iat-category-header__control-description--large iat-category-header__aux">
                {{ categories.bottomLeft && categories.bottomLeft.title }}
            </div>
        </div>

        <div
            v-if="showRight"
            class="iat-category-header__control-description text-center"
        >
            <div class="iat-category-header__control-description--small iat-category-header__control-description--mobile">
                {{ $t(`${TEXT_TYPES.INTERACTION_BASE}_IAT_PRESS_RIGHT_MOBILE`) }}
            </div>
            <div class="iat-category-header__control-description--small iat-category-header__control-description--desktop">
                {{ $t(`${TEXT_TYPES.INTERACTION_BASE}_IAT_PRESS_RIGHT`) }}
            </div>
            <div v-if="categories.topRight && !categories.topRight.isHidden" class="iat-category-header__control-description--large iat-category-header__target">
                {{ categories.topRight && categories.topRight.title }}
            </div>
            <div v-if="categories.bottomRight && !categories.bottomRight.isHidden && categories.topRight && !categories.topRight.isHidden" class="iat-category-header__control-description--small">
                {{ $t(`${TEXT_TYPES.INTERACTION_BASE}_IAT_PRESS_OR`) }}
            </div>
            <div v-if="categories.bottomRight && !categories.bottomRight.isHidden" class="iat-category-header__control-description--large iat-category-header__aux">
                {{ categories.bottomRight && categories.bottomRight.title }}
            </div>
        </div>

    </div>
</template>
<script>
import { TEXT_TYPES } from '@/constants/i18n'

export default {
    name: 'iatCategoryHeader',
    props: {
        categories: {
            type: Object
        }
    },
    data() {
        return {
            TEXT_TYPES
        }
    },
    computed: {
        showLeft() {
            return (this.categories.topLeft && !this.categories.topLeft.isHidden) || (this.categories.bottomLeft && !this.categories.bottomLeft.isHidden)
        },
        showRight() {
            return (this.categories.topRight && !this.categories.topRight.isHidden) || (this.categories.bottomRight && !this.categories.bottomRight.isHidden)
        },
        positioning() {
            const verticalAlign = (this.categories.bottomLeft && this.categories.bottomLeft.title) || (this.categories.bottomRight && this.categories.bottomRight.title) ? '' : 'align-items-center'
            let horizontalAlign = this.showRight && this.showLeft ? 'justify-content-between' : 'justify-content-center'

            return `${verticalAlign} ${horizontalAlign}`
        }
    }
}
</script>
<style lang="scss">
.iat-category-header {
    border-bottom: 1px solid $bq-turquoise;
    margin-left: -15px;
    margin-right: -15px;
    @media (min-width: 992px) {
        font-size: 1.15em;
    }
}

.iat-category-header__control-description {
    width: 120px;
    @media (min-width: 992px) {
        width: 170px;
    }
    line-height: 1.25em;
    color: $main-font-grey;
    &--small {
        font-size: 0.85em;
    }
    &--mobile {
        @media (pointer: fine) {
            display: none;
        }
    }
    &--desktop {
        @media (pointer: coarse) {
            display: none;
        }
    }
}


.iat-category-header__target {
    font-weight: 600;
    color: #437598;
}

.iat-category-header__aux {
    font-weight: 600;
    color: #cc574c;
}
</style>